"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MediaGalleryItem = void 0;
const react_1 = __importDefault(require("react"));
const lazy_1 = __importDefault(require("react-player/lazy"));
const core_serving_bs_lazy_render_1 = require("@hotelplan/core.serving.bs-lazy-render");
const fdr_media_gallery_media_item_styles_1 = require("./fdr-media-gallery-media-item.styles");
const MediaGalleryItem = props => {
    const { className, lazy, loading, data, isThumbnail, height } = props;
    let item = null;
    const { refEl, entered } = (0, core_serving_bs_lazy_render_1.useElementEnteredViewport)();
    if (isThumbnail) {
        const image = data.__typename === 'FdrImage'
            ? Object.assign(Object.assign({}, data), { resized: data.thumbnailResized }) : Object.assign({}, data.thumbnail);
        return (react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrImageMediaWrap, { "data-id": "media-image", className: "image", image: image }));
    }
    switch (data.__typename) {
        case 'FdrImage': {
            item = (react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrImageMediaWrap, { "data-id": "media-image", className: "image", image: (data === null || data === void 0 ? void 0 : data.image) ? data.image : data, onClick: data === null || data === void 0 ? void 0 : data.onClick, lazy: lazy, loading: loading }));
            break;
        }
        case 'FdrVideo':
            item = (react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrVideoMediaWrap, { ref: refEl, className: "video", "data-id": "music-media", height: height }, entered && (react_1.default.createElement(lazy_1.default, { playing: false, controls: true, muted: false, url: data.resourceLink.url, width: "100%", height: "100%" }))));
            break;
        case 'FdrAudio':
            item = (react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrAudioMediaWrap, { ref: refEl, className: "music", "data-id": "music-media" },
                react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrImageMediaWrap, { image: data.image, className: "image", lazy: lazy, loading: loading }),
                entered && (react_1.default.createElement(lazy_1.default, { playing: false, controls: true, url: data.resourceLink.url, width: "100%", height: "100%", style: {
                        position: 'absolute',
                        top: 0,
                    } }))));
            break;
        case 'FdrExternalMedia':
            item = (react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrExternalMediaLinkWrap, { className: "external", href: data.resourceLink.url, "data-id": "external-media", target: "_blank" },
                react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrImageMediaWrap, { image: data.image, lazy: lazy, className: "image", loading: loading })));
            break;
        case 'FdrPdf':
            item = (react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrExternalMediaLinkWrap, { className: "pdf", href: data.resourceLink.url, "data-id": "pdf-media", target: "_blank" },
                react_1.default.createElement(fdr_media_gallery_media_item_styles_1.FdrImageMediaWrap, { image: data.image, lazy: lazy })));
            break;
        default:
            break;
    }
    return react_1.default.createElement("div", { className: className }, item);
};
exports.MediaGalleryItem = MediaGalleryItem;
//# sourceMappingURL=fdr-media-gallery-media-item.js.map